import { axiosInstance } from "@/api/axiosInstance"
import { AxiosRequestConfig } from "axios"
import { UserFeedbackApi } from "swagger/api"
import { CreateFeedbackRequest } from "swagger/models"
import { Configuration } from "../../swagger/configuration"
import { getFirebaseIDToken } from "./auth/firebase"

const getAccessToken = async () => {
  const accessToken = await getFirebaseIDToken()
  return accessToken
}

const getApiConfig = () =>
  new Configuration({
    basePath: process.env.NEXT_PUBLIC_API_URL,
    //@ts-ignore
    accessToken: getAccessToken,
  })

const apiConfiguration = getApiConfig()

const USER_FEEDBACK_API = new UserFeedbackApi(apiConfiguration, apiConfiguration.basePath, axiosInstance)

export const sendUserFeedback = async (body: CreateFeedbackRequest, options?: AxiosRequestConfig) => {
  return USER_FEEDBACK_API.createUserFeedback(body, options)
}
